import URLSearchParams from '@/utils/URLSearchParams'
import { getDefaultPlan } from '@/api/services'

export async function loadDefaultPlan () {
  const { partner = '' } = URLSearchParams()
  const planResponse = await getDefaultPlan(partner)
  const plan = planResponse.data[0]

  const monthlyAndAnnualPlan = ['MONTHLY', 'YEARLY']
    .reduce((plans, type) => {
      const plan = planResponse.data.find(plan => plan.frequency === type)
      plan && plans.push(plan)
      return plans
    }, [])

  const product = {
    alias: 'saude',
    api: 'internal-health',
    aliasEN: 'health',
    redirect: '/sucesso/',
    redirectError: '/rejeicao/',
    sessionName: 'semprebem:health',
    lead: { uuid: null },
    distribuitionPartner: partner,
    plan: {
      pontuacao: 0,
      uuid: plan.uuid,
      precoTotal: plan.value,
      name: plan.description,
      preco: plan.value,
      category: plan.category,
      type: plan.planType,
      counterDependent: 0,
      listPersons: [],
      promoCode: { code: null, applied: false, error: null, enable: true },
      ...(monthlyAndAnnualPlan.length === 2 && {
        isMonthlyAndAnnualPlan: true,
        plans: monthlyAndAnnualPlan
      }),
      ...(plan.promo?.active && {
        campaign: { ...plan.promo }
      })
    },
    default: { completePrice: plan.value },
    promo: { completePrice: 0 }
  }

  sessionStorage.setItem('semprebem:product', JSON.stringify(product))
}

export default function productConfigs () {
  const product = JSON.parse(sessionStorage.getItem('semprebem:product'))

  if (!product) return

  const productsList = [
    { product: 'health', alias: 'saude' }
  ]

  const fileName = productsList.find(item => {
    return item.alias === product.alias
  }).product

  const { productBasicData } = require(`./${fileName}.js`)

  return Object.assign(productBasicData)
}
